import wikiImg from '../../image/wikipediaExternalPage.png'
import ManagersContext from '../../containers/ManagersContext'
import { useContext } from 'react'
export default function InnerPageCode () {
  const {objGitRepos} = useContext(ManagersContext)

  return (
    <div>
      <header>
        <h1>Code</h1>
        <p>Here are some code samples hosted on GitHub.</p>
      </header>
      <section>
        {
          objGitRepos.repos.map((repo, i:number) => (
            <dl key={`dt_${i}`}>
              <dt>
                <a href={`${objGitRepos.gitUrlFront}/${repo.repoName}`} target='BLANK' rel='ext'>
                  {repo.title}&nbsp;<img src={wikiImg} alt='External Page' />
                </a>
              </dt>
              <dd dangerouslySetInnerHTML={{ __html: repo.desc }} />
            </dl>
          ))
        }
        <dl>
          <dt><a href='https://gist.github.com/gregsandell' target='BLANK' rel='ext'>My Git Gists</a></dt>
          <dd>Short solutions I keep handy when I don't want to keep reinventing wheels.</dd>
        </dl>
      </section>
    </div>
  )
}
